/**
 * The product's own name and marks, in one place.
 *
 * One module rather than string literals scattered through the screens, for two reasons. The rename
 * from AFilter showed how many places a name ends up in, and a second rename should be one edit. And
 * an MSP reselling this console may one day ask for it to carry their name instead of ours; a
 * constant here is the seam that request would widen into a per-deployment value, where a hundred
 * literals would be a hundred edits (D-513).
 *
 * The code identifiers - storage keys, headers, namespaces - deliberately keep the old name and are
 * not here. They are not seen, and renaming them would sign everybody out (ADR-S-050).
 */
export const PRODUCT_NAME = 'Coastline'

export const PRODUCT_TAGLINE = 'AI usage insights for businesses'

/**
 * Imported rather than served from `public/`, so the build names each file by its content.
 *
 * They used to be fixed names under `/brand/` with a day's cache, and the first redraw of the sign-in
 * art showed what that costs: a browser that had seen the old pixels kept them for up to a day, and
 * the only cure was a hard refresh. Now Vite emits `/assets/Coastline-v2-960x1200-<hash>.png`. The same
 * pixels keep the same URL and stay cached for a year under `/assets/`, and new pixels get a new URL
 * the moment `index.html` - which is never cached - points at it. Nobody has to remember to bump
 * anything.
 *
 * The favicons and the manifest cannot do this, because browsers ask for them by fixed name. They
 * stay in `public/`, and `deploy/nginx/spa.conf` makes the browser revalidate them instead (D-532).
 */
import icon from '../assets/brand/coastline-icon.svg'
import logoLight from '../assets/brand/coastline-logo-horizontal-h80.png'
import logoDark from '../assets/brand/coastline-logo-horizontal-dark-h80.png'
import signInArt from '../assets/brand/Coastline-v2-960x1200.png'

export const PRODUCT_ASSETS = { icon, logoLight, logoDark, signInArt } as const
